export default __webpack_public_path__ + "static/media/img_5.55b118a5.JPG";